/**
 * Cart Vehicle Validation
 * Validates cart items against selected vehicle before checkout
 *
 * TOGGLE: Set ENABLED to false to disable this feature
 */

(function() {
  'use strict';

  // ============================================
  // CONFIGURATION - Toggle feature on/off here
  // ============================================
  const CONFIG = {
    ENABLED: false,  // Set to false to disable validation
    DEBUG: false,   // Set to true for console logging
    EXPERT_EMAIL: 'info@overlandadventure.com' // Email for "Check with experts" button
  };

  // Exit if disabled
  if (!CONFIG.ENABLED) {
    if (CONFIG.DEBUG) console.log('[Cart Validation] Feature disabled');
    return;
  }

  // ============================================
  // MAIN VALIDATION LOGIC
  // ============================================
  const CartVehicleValidation = {

    // Get selected vehicle from storage
    getSelectedVehicle() {
      return sessionStorage.getItem('selectedVehicle');
    },

    // Get all cart items with their vehicle compatibility
    getCartItems() {
      const items = document.querySelectorAll('[data-cart-item-vehicles]');
      return Array.from(items).map(item => ({
        element: item,
        name: item.dataset.cartItemName || 'Unknown Product',
        vehicles: item.dataset.cartItemVehicles || '',
        key: item.dataset.key || ''
      }));
    },

    // Check if product is compatible with vehicle
    isCompatible(productVehicles, selectedVehicle) {
      if (!productVehicles || !selectedVehicle) return true; // No data = assume compatible
      const vehicleList = productVehicles.split('|').map(v => v.trim());
      return vehicleList.includes(selectedVehicle);
    },

    // Find incompatible items in cart
    findIncompatibleItems(selectedVehicle) {
      const cartItems = this.getCartItems();
      return cartItems.filter(item => {
        // Skip items with no vehicle data (universal products)
        if (!item.vehicles || item.vehicles.trim() === '') return false;
        return !this.isCompatible(item.vehicles, selectedVehicle);
      });
    },

    // Show validation modal
    showModal(selectedVehicle, incompatibleItems) {
      // Remove existing modal
      const existing = document.getElementById('cart-vehicle-modal');
      if (existing) existing.remove();

      // Build item list HTML
      const itemsHtml = incompatibleItems.map(item =>
        `<li style="padding:8px 0;border-bottom:1px solid #eee;">${item.name}</li>`
      ).join('');

      // Create modal
      const modal = document.createElement('div');
      modal.id = 'cart-vehicle-modal';
      modal.innerHTML = `
        <div style="
          position:fixed;top:0;left:0;width:100%;height:100%;
          background:rgba(0,0,0,0.85);z-index:999999;
          display:flex;align-items:center;justify-content:center;
        ">
          <div style="
            background:white;padding:30px;border-radius:12px;
            max-width:500px;width:90%;max-height:80vh;overflow-y:auto;
          ">
            <h2 style="margin-top:0;color:#333;font-size:22px;">
              ⚠️ Vehicle Compatibility Warning
            </h2>
            <p style="color:#666;">
              Your selected vehicle: <strong>${selectedVehicle}</strong>
            </p>
            <p style="color:#c00;font-weight:600;">
              The following items may not be compatible:
            </p>
            <ul style="list-style:none;padding:0;margin:0 0 20px 0;max-height:200px;overflow-y:auto;">
              ${itemsHtml}
            </ul>
            <div style="display:flex;flex-direction:column;gap:10px;">
              <button id="cart-validate-proceed" style="
                padding:14px 20px;background:#4caf50;color:white;
                border:none;border-radius:8px;cursor:pointer;font-weight:600;
              ">
                Proceed Anyway - I Understand
              </button>
              <button id="cart-validate-change" style="
                padding:14px 20px;background:#2196f3;color:white;
                border:none;border-radius:8px;cursor:pointer;font-weight:600;
              ">
                Change My Vehicle
              </button>
              <a id="cart-validate-experts" href="mailto:${CONFIG.EXPERT_EMAIL}?subject=${encodeURIComponent('Vehicle Compatibility Question - ' + selectedVehicle)}&body=${encodeURIComponent('Hi, I have items in my cart that may not be compatible with my ' + selectedVehicle + ':\n\n' + incompatibleItems.map(i => '- ' + i.name).join('\n') + '\n\nCan you help me confirm compatibility?')}" style="
                padding:14px 20px;background:#ff9800;color:white;
                border:none;border-radius:8px;cursor:pointer;font-weight:600;
                text-align:center;text-decoration:none;display:block;
              ">
                Check with Experts
              </a>
              <button id="cart-validate-cancel" style="
                padding:14px 20px;background:#eee;color:#333;
                border:none;border-radius:8px;cursor:pointer;font-weight:600;
              ">
                Return to Cart
              </button>
            </div>
          </div>
        </div>
      `;

      document.body.appendChild(modal);
      this.bindModalEvents(modal);
    },

    // Show "no vehicle selected" modal
    showNoVehicleModal() {
      const existing = document.getElementById('cart-vehicle-modal');
      if (existing) existing.remove();

      const modal = document.createElement('div');
      modal.id = 'cart-vehicle-modal';
      modal.innerHTML = `
        <div style="
          position:fixed;top:0;left:0;width:100%;height:100%;
          background:rgba(0,0,0,0.85);z-index:999999;
          display:flex;align-items:center;justify-content:center;
        ">
          <div style="
            background:white;padding:30px;border-radius:12px;
            max-width:450px;width:90%;
          ">
            <h2 style="margin-top:0;color:#333;font-size:22px;">
              🚗 Please Select Your Vehicle
            </h2>
            <p style="color:#666;margin-bottom:25px;">
              To ensure you're ordering compatible parts, please select your vehicle before checkout.
            </p>
            <div style="display:flex;flex-direction:column;gap:10px;">
              <button id="cart-validate-select" style="
                padding:14px 20px;background:#4caf50;color:white;
                border:none;border-radius:8px;cursor:pointer;font-weight:600;
              ">
                Select My Vehicle
              </button>
              <button id="cart-validate-skip" style="
                padding:14px 20px;background:#eee;color:#333;
                border:none;border-radius:8px;cursor:pointer;font-weight:600;
              ">
                Skip - Proceed Without Selecting
              </button>
            </div>
          </div>
        </div>
      `;

      document.body.appendChild(modal);

      // Bind events
      modal.querySelector('#cart-validate-select').addEventListener('click', () => {
        modal.remove();
        // Open vehicle selector popup
        const popup = document.getElementById('vehicle-selector-popup');
        if (popup) popup.style.display = 'flex';
      });

      modal.querySelector('#cart-validate-skip').addEventListener('click', () => {
        modal.remove();
        this.proceedToCheckout();
      });
    },

    // Bind modal button events
    bindModalEvents(modal) {
      modal.querySelector('#cart-validate-proceed').addEventListener('click', () => {
        modal.remove();
        this.proceedToCheckout();
      });

      modal.querySelector('#cart-validate-change').addEventListener('click', () => {
        modal.remove();
        const popup = document.getElementById('vehicle-selector-popup');
        if (popup) popup.style.display = 'flex';
      });

      modal.querySelector('#cart-validate-cancel').addEventListener('click', () => {
        modal.remove();
      });
    },

    // Submit form to checkout
    proceedToCheckout() {
      // Find and submit the cart form
      const form = document.getElementById('CartPageForm') ||
                   document.querySelector('.cart__drawer-form');
      if (form) {
        // Temporarily disable validation to prevent loop
        this.bypassValidation = true;

        // Create and click a hidden submit button
        const submitBtn = document.createElement('button');
        submitBtn.type = 'submit';
        submitBtn.name = 'checkout';
        submitBtn.style.display = 'none';
        form.appendChild(submitBtn);
        submitBtn.click();
      }
    },

    // Remove the loading spinner from checkout button
    clearCheckoutSpinner() {
      const btns = document.querySelectorAll('.cart__checkout');
      btns.forEach(btn => btn.classList.remove('btn--loading'));
    },

    // Main validation handler
    validate(evt) {
      // Skip if bypass flag is set
      if (this.bypassValidation) {
        this.bypassValidation = false;
        return true;
      }

      const selectedVehicle = this.getSelectedVehicle();

      // Check if vehicle is selected
      if (!selectedVehicle) {
        evt.preventDefault();
        this.clearCheckoutSpinner();
        this.showNoVehicleModal();
        return false;
      }

      // Find incompatible items
      const incompatibleItems = this.findIncompatibleItems(selectedVehicle);

      if (incompatibleItems.length > 0) {
        evt.preventDefault();
        this.clearCheckoutSpinner();
        this.showModal(selectedVehicle, incompatibleItems);
        if (CONFIG.DEBUG) {
          console.log('[Cart Validation] Incompatible items:', incompatibleItems);
        }
        return false;
      }

      // All good - proceed
      if (CONFIG.DEBUG) console.log('[Cart Validation] All items compatible');
      return true;
    },

    // Initialize - use document-level event delegation to catch all cart form submissions
    // This ensures it works even when the cart drawer hydrates after DOMContentLoaded
    init() {
      document.addEventListener('submit', (e) => {
        const form = e.target;
        // Only intercept cart forms (cart page form or cart drawer form)
        if (form.id === 'CartPageForm' || form.classList.contains('cart__drawer-form')) {
          // Only intercept if the submit was triggered by a checkout button
          const submitBtn = form.querySelector('button[name="checkout"]');
          const activeEl = document.activeElement;
          const isCheckout = (activeEl && activeEl.name === 'checkout') ||
                             (e.submitter && e.submitter.name === 'checkout');
          if (isCheckout) {
            this.validate(e);
          }
        }
      });

      if (CONFIG.DEBUG) console.log('[Cart Validation] Initialized with document-level delegation');
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => CartVehicleValidation.init());
  } else {
    CartVehicleValidation.init();
  }

})();
